<template>
  <div>
    <PageTitle
      title="Create Stock Transfer"
      :backBtn="true"
      :showLoading="isLoading"
    />
    <v-container fluid class="lighten-12 container">
      <ValidationObserver ref="observer">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="3">
            <v-card>
              <v-card-title>General</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="6" md="6" lg="12">
                    <ValidationProvider name="Ware House" rules="required">
                      <WarehouseAutoComplete
                        @changeFilter="getWarehouseProductsByQuery()"
                      >
                      </WarehouseAutoComplete>
                      <!-- <v-autocomplete
                        slot-scope="{ errors }"
                        outlined
                        hide-details="auto"
                        v-model="StockTransfer.from_ware_house_id"
                        item-text="name"
                        item-value="id"
                        :items="warehouses"
                        @change="getProductsByQuery(StockTransfer)"
                        :search-input.sync="searchWarehouse"
                        :loading="warehouseLoading"
                        :error-messages="errors"
                        label="Warehouse"
                        required
                      ></v-autocomplete> -->
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="12">
                    <ValidationProvider name="Shop" rules="required">
                      <v-autocomplete
                        slot-scope="{ errors }"
                        outlined
                        hide-details="auto"
                        v-model="StockTransfer.to_shop_id"
                        item-text="name"
                        item-value="id"
                        :items="shops"
                        @change="getProductsByQuery(StockTransfer)"
                        :search-input.sync="searchShop"
                        :loading="shopLoading"
                        :error-messages="errors"
                        label="Shop"
                        required
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <ValidationProvider rules="required" name="Datetime">
                      <datePickComponent
                        hide-details="auto"
                        slot-scope="{ errors }"
                        v-model="StockTransfer.date"
                        labelname="Date"
                        :error-messages="errors"
                        required
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="9">
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col cols="4" style="padding: 0"
                    >Choose Products to transfer</v-col
                  >
                  <!-- <v-col cols="4" style="padding:0"></v-col> -->
                  <v-col cols="12" style="padding: 0">
                    <!-- <v-autocomplete
                    
                      v-model="product"
                      :items="products"
                      hide-details="auto"
                      item-text="name"
                      class="ma-2"
                      item-value="id"
                      label="search product"
                      outlined
                      dense
                      @change="AssignListToProduct(product)"
                      :search-input.sync="searchProduct"
                      :loading="productGetLoading"
                      :error-messages="errors"
                      
                    >
                      
                    </v-autocomplete> -->
                  </v-col>
                </v-row>
              </v-card-title>

              <v-container fluid>
                <v-row>
                  <v-card-text class="pa-0">
                    <v-data-table
                      :items-per-page="paginationOptions.perPage"
                      :fixed-header="true"
                      :single-expand="singleExpand"
                      :expanded.sync="expanded"
                      @click:row="GetBatchDetails($event)"
                      show-expand
                      :headers="headers"
                      :items="stocks"
                      item-key="id"
                      hide-default-footer
                      class="row-pointer product-list"
                      expand
                      dense
                    >
                      <template v-slot:top>
                        <v-toolbar flat>
                          <v-btn
                            @click="openTransferModal()"
                            v-if="
                              StockTransfer.to_shop_id &&
                              selectedItemToTransfer.length > 0
                            "
                            color="primary"
                            dark
                            class="mb-2"
                            v-bind="attrs"
                            v-on="on"
                          >
                            Transfer
                          </v-btn>
                          <div
                            v-if="
                              !StockTransfer.to_shop_id &&
                              selectedItemToTransfer.length > 0
                            "
                          >
                            <h6
                              v-if="!StockTransfer.date"
                              style="
                                font-size: 16px;
                                font-weight: 1200;
                                align-items: center;
                                color: red;
                              "
                            >
                              * Please Select Date
                            </h6>
                            <h6
                              style="
                                font-size: 16px;
                                font-weight: 1200;
                                align-items: center;
                                color: red;
                              "
                            >
                              * Please Select Shop
                            </h6>
                          </div>
                          <v-spacer></v-spacer>
                          <!-- <v-switch
                      v-model="batchHeaders[3].show"
                      label="Transfer Stock"
                      class="mt-2"
                      @change="onToggleChanged()"
                    ></v-switch> -->
                        </v-toolbar>
                      </template>

                      <template v-slot:item.available_stock="{ item }">
                        <v-chip
                          :x-small="true"
                          class="ma-2"
                          label
                          text-color="white"
                          :color="getStockColor(item)"
                          dark
                          >{{ item.available_stock }}</v-chip
                        >
                      </template>
                      <template
                        v-slot:expanded-item="{
                          headers,
                          child: childItem,
                          item,
                        }"
                      >
                        <td :colspan="headers.length">
                          <v-card class="pa-0 mt-3 mb-3">
                            <v-data-table
                              dense
                              :items="stockBatches"
                              :headers="batchHeaders"
                              class="sub-table"
                              :fixed-header="true"
                              hide-default-footer
                              expand
                            >
                              <template v-slot:item.isTransfer="{ item }">
                                <v-checkbox
                                  v-if="item.available_stock > 0"
                                  v-model="item.isTransfer"
                                  color="indigo darken-3"
                                  @change="AddItemToTransfer(item)"
                                  hide-details
                                ></v-checkbox>
                              </template>
                              <v-progress-linear
                                v-show="progressBar"
                                slot="progress"
                                color="blue"
                                indeterminate
                              ></v-progress-linear>

                              <!-- Action -->
                              <template v-slot:item.action="{ item }">
                                <v-list-item
                                  link
                                  @click="EditStockDetails(item)"
                                >
                                  <span>
                                    <v-icon v-bind="attrs" v-on="on"
                                      >mdi-pencil-box-outline</v-icon
                                    >Edit
                                  </span>
                                </v-list-item>
                              </template>
                            </v-data-table>
                          </v-card>
                        </td>
                      </template>
                      <template v-slot:no-data>
                        <img
                          style="height: 200px"
                          src="../../../assets/img/no-result.jpg"
                        />
                      </template>

                      <template v-slot:item.image="{ item }">
                        <v-avatar size="32px" item color="primary">
                          <img
                            v-if="item.product.image"
                            :src="item.product.image"
                          />
                          <span
                            v-else
                            class="white--text subtitle-2 text-uppercase"
                          >
                            {{ item.product.name.substring(0, 2) }}</span
                          >
                        </v-avatar>
                      </template>
                      <template
                        v-slot:item.data-table-expand="{
                          item,
                          isExpanded,
                          expand,
                        }"
                      >
                        <span
                          @click="GetBatchDetails($event)"
                          v-if="
                            (expanded.length > 0 &&
                              item.id != expanded[0].id) ||
                            expanded.length == 0
                          "
                          class="mdi mdi-chevron-double-down"
                        ></span>
                        <span
                          @click="GetBatchDetails($event)"
                          v-if="
                            expanded.length > 0 && item.id == expanded[0].id
                          "
                          class="mdi mdi-chevron-double-up"
                        ></span>
                      </template>
                      <template v-slot:footer>
                        <pagination
                          @paginationOptions="setPaginationOptions"
                          @response="setResponseData"
                          @getPageNumber="setPagenumber"
                          url="stocks"
                          :filter="filter"
                          :transferCreate="true"
                          ref="pagination"
                        />
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <TransferStockModal
          :productDetails="selectedItemToTransfer"
          :ProductsData="StockTransfer"
          ref="TransferForm"
          @conform="refreshBatches($event)"
        />
        <!-- <WareHouseStock
        :visible="isCategoryFormVisible"
        :StockAdjustment="ShopStockDetails"
        @close="AddCategory($event)"
        @afterSave="refreshData()"
      /> -->
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import datePickComponent from '../../../components/base/DateComponent';
import WareHouseStock from './WarehouseAdjustable';

import pagination from '../../shared/components/pagination';
import WarehouseAutoComplete from './WarehouseAutoComplete.vue';
import TableFilters from '@/components/base/TableFilters';
import TransferStockModal from './TransferStockModal';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import _ from 'lodash';
import moment from 'moment';
import FileUpload from '@/components/base/FileUpload';
import { StockTransferModel } from '@/models/StockTransferModel';
import { required, email, max } from 'vee-validate/dist/rules';
import { Product } from '../../../models/Product';
import { mapState } from 'vuex';

extend('required', {
  ...required,
  message: '{_field_} is required',
});

export default {
  data: () => ({
    messages: [],
    errors: [],
    warehouses: [],
    products: [],
    shops: [],
    shopLoading: false,
    warehouseLoading: false,
    searchWarehouse: '',
    searchProduct: null,

    productGetLoading: false,

    StockTransfer: new StockTransferModel(),
    paginationOptions: {},
    progressBar: false,
    selectedItemToTransfer: [],
    selectedWarehouse: null,
    searchShop: null,
    TransferStock: false,
    selectedProductDetails: null,
    batchHeaders: [
      {
        text: '',
        value: 'isTransfer',
        show: false,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
      {
        text: 'Batch',
        value: 'batch.batch',
        show: true,
        align: 'left',
        disabled: true,
        width: '14.2%',
      },
      {
        text: 'In Stock',
        value: 'available_stock',
        show: true,
        align: 'center',
        disabled: true,
        width: '14.2%',
      },
      {
        text: 'Damage',
        value: 'damage',
        show: true,
        align: 'center',
        disabled: false,
        width: '14.2%',
      },
    ],
    columns: [
      {
        text: 'Image',
        value: 'image',
        show: true,
        disabled: true,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'Product',
        value: 'product.name',
        show: true,
        disabled: true,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'Unit',
        value: 'unit.name',
        align: 'left',
        show: true,
        disabled: false,
        width: '14.2%',
      },
      {
        text: 'Warehouse',
        value: 'wareHouse.name',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.2%',
      },
      {
        text: 'In Stock',
        value: 'available_stock',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
      {
        text: 'Damage',
        value: 'damage',
        show: true,
        disabled: false,
        align: 'center',
        width: '16.2%',
      },
      {
        text: 'Reorder Level',
        value: 'reorder_level',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.2%',
      },
    ],
    products: [],
    ShopStockDetails: {
      warehouse_id: null,
      product_id: null,
      batch_id: null,
      unit_id: null,
    },
    stocks: [],
    expanded: [],
    isCategoryFormVisible: false,
    singleExpand: true,
    stockBatches: [],
    product: null,
    // Filters
    filter: {
      warehouse: '',
      shop: '',
      search: '',
      product: '',
      date: new Date(),
    },
  }),
  computed: {
    ...mapState(['StockTransferWarehouse']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  mounted() {
    this.filter.shop = this.StockTransfer.to_shop_id;
    this.filter.warehouse = this.StockTransfer.from_ware_house_id;
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    FileUpload,
    pagination,
    TableFilters,
    TransferStockModal,
    WareHouseStock,
    WarehouseAutoComplete,
  },

  methods: {
    AssignListToProduct(data) {
      this.filter.product = data;
    },
    getProductsByQuery(data) {
      this.selectedItemToTransfer = [];
      this.filter.shop = data.to_shop_id;
      this.filter.warehouse = this.StockTransferWarehouse;
      this.StockTransfer.from_ware_house_id = this.StockTransferWarehouse;
    },
    getShopsByQuery(query = '') {
      this.shopLoading = true;
      this.$store
        .dispatch('warehouse/GetShops', { query: query })
        .then((res) => {
          this.shops = res;
          this.shopLoading = false;
        })
        .catch((err) => {
          this.shopLoading = false;
          this.messages = err.data.name;
        });
    },
    EditStockDetails(data) {
      // ;
      this.isCategoryFormVisible = true;
      this.editBatchId = data.batch.id;
      this.ShopStockDetails.batch_id = data.batch.id;
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    AddCategory($event) {
      this.isCategoryFormVisible = false;
    },
    onToggleChanged() {
      this.filter.date = new Date();
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(productData) {
      this.expanded = [];
      this.stocks = this.groupStock(productData);
      //     this.filter.shop = this.StockTransfer.to_shop_id;
      // this.filter.warehouse = this.StockTransfer.from_ware_house_id;
    },
    getWarehouseProductsByQuery() {
      this.filter.warehouse = this.StockTransferWarehouse;
      // this.$refs.TransferForm.openModal();
    },
    openTransferModal() {
      this.$refs.TransferForm.openModal();
    },

    groupStock(productData) {
      let groupedArray = _.groupBy(productData, function (entry) {
        return (
          entry.wareHouse.id + ',' + entry.unit.id + ',' + entry.product.id
        );
      });
      return Object.keys(groupedArray).map((key) => {
        let actual_stock = _.sumBy(groupedArray[key], 'actual_stock');
        let available_stock = _.sumBy(groupedArray[key], 'available_stock');
        let background = 'green';
        if (0 < available_stock > groupedArray[key][0].reorder_level) {
          background = 'orange';
        } else if (available_stock <= 0) {
          let background = '#dd000017';
        }
        return {
          actual_stock: actual_stock,
          available_stock: available_stock,
          batch: groupedArray[key][0].batch,
          damage: _.sumBy(groupedArray[key], 'damage'),
          id: groupedArray[key][0].id,
          product: groupedArray[key][0].product,
          reorder_level: groupedArray[key][0].reorder_level,
          unit: groupedArray[key][0].unit,
          wareHouse: groupedArray[key][0].wareHouse,
          background: background,
        };
      });
    },
    clearFilter() {
      this.filter = {};
    },
    AddItemToTransfer(item) {
      let productBatch = new Object();
      productBatch.productDetail = this.selectedProductDetails;
      productBatch.details = item;
      productBatch.productDetail.quantity = item.available_stock;
      productBatch.productDetail.maxStock = item.available_stock;
      // productBatch.productDetail.available_stock=item.available_stock;

      if (
        this.selectedWarehouse &&
        this.selectedWarehouse != this.selectedProductDetails.wareHouse.id
      ) {
        this.$confirm(
          `you can transfer to one warehouse at a time Do you want to change to new Warehouse  previous selected warehouse Transfer will be lost`,
        ).then((res) => {
          if (res) {
            this.selectedItemToTransfer = [];
            this.selectedWarehouse = this.selectedProductDetails.wareHouse.id;
            if (item.isTransfer) {
              item.error = [];

              this.selectedItemToTransfer.push(_.cloneDeep(productBatch));
            } else {
              let index = this.selectedItemToTransfer.findIndex(
                (p) =>
                  p.productDetail.product.id ==
                    this.selectedProductDetails.product.id &&
                  p.productDetail.wareHouse.id == item.wareHouse.id &&
                  p.details.batch.id == item.batch.id,
              );
              if (index != -1) {
                this.selectedItemToTransfer.splice(index, 1);
              }
            }
          } else {
            item.isTransfer = false;
          }
        });
      } else {
        this.selectedWarehouse = this.selectedProductDetails.wareHouse.id;
        if (item.isTransfer) {
          item.error = [];
          this.selectedItemToTransfer.push(_.cloneDeep(productBatch));
          item.quantity = item.available_stock;
        } else {
          let index = this.selectedItemToTransfer.findIndex(
            (p) =>
              p.productDetail.product.id ==
                this.selectedProductDetails.product.id &&
              p.productDetail.wareHouse.id ==
                this.selectedProductDetails.wareHouse.id &&
              p.details.batch.id == item.batch.id,
          );
          if (index != -1) {
            this.selectedItemToTransfer.splice(index, 1);
          }
        }
      }
    },
    GetBatchDetails(event) {
      this.progressBar = true;
      if (this.expanded.length > 0 && this.expanded[0].id == event.id) {
        this.expanded = [];
      } else {
        const payload = new Object();
        this.selectedProductDetails = event;
        payload.product_id = event.product.id;
        payload.warehouse_id = event.wareHouse.id;
        payload.unit_id = event.unit.id;

        this.ShopStockDetails.product_id = event.product.id;
        this.ShopStockDetails.warehouse_id = event.wareHouse.id;
        this.ShopStockDetails.unit_id = event.unit.id;

        payload.date = moment(this.filter.date).utc().format(); //moment(this.filter.date).format("DD-MM-YYYY HH:MM:SS");
        this.$store
          .dispatch('stock/GetBatchForStocksinExpandTable', payload)
          .then((resp) => {
            this.progressBar = false;
            this.stockBatches = [];
            resp.map((r) => {
              let selectedProduct = this.selectedItemToTransfer.find((p) => {
                p.productDetail.product.id == event.product.id &&
                  p.productDetail.wareHouse.id == event.wareHouse.id &&
                  p.details.batch.id == r.batch.id;
              });

              if (selectedProduct) {
                r.isTransfer = true;
              } else {
                r.isTransfer = false;
              }

              if (r.available_stock > 0) {
                this.stockBatches.push(r);
              }
            });
          })
          .catch((error) => console.log(error));
        this.expanded = [];
        this.progressBar = false;
        this.expanded.push(event);
      }
    },
    getStockColor(stock) {
      if (
        0 < stock.available_stock &&
        stock.available_stock < stock.reorder_level
      ) {
        return 'orange';
      } else if (stock.available_stock < 1) {
        return 'red';
      } else {
        return 'green';
      }
    },

    GetSiteSetting() {
      this.$store
        .dispatch('sitesetting/SiteSettingView', 1)
        .then((res) => {
          let self = this;
          self.siteSetting = res.data;
          this.$store.commit(
            'UPDATE_STOCK_TRANFER_WAREHOUSE_QUERY_FILTER',
            this.siteSetting.wareHouse.name,
          );
          this.$store.commit(
            'UPDATE_STOCK_TRANFER_WAREHOUSE_FILTER',
            this.siteSetting.wareHouse.id,
          );

          // this.searchWarehouse = self.siteSetting.wareHouse.name;
          // this.StockTransfer.from_ware_house_id = self.siteSetting.wareHouse.id;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
    getProductsSearchByQuery(query = '') {
      this.productGetLoading = true;
      this.$store
        .dispatch('product/GetProduct', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.products = res.map((u, i, arr) => {
            u.index = i + 1;
            return new Product().toViewModel(u);
          });

          this.productGetLoading = false;
        })
        .catch((err) => {
          this.productGetLoading = false;
          this.messages = err.data.title;
        });
    },
  },

  created() {
    this.getShopsByQuery();
    this.GetSiteSetting();
    this.StockTransfer.from_ware_house_id = this.StockTransferWarehouse;
  },
  watch: {
    searchProduct(value) {
      if (!value) {
        this.getProductsSearchByQuery('');
      }
      this.getProductsSearchByQuery(value);
    },

    searchShop(value) {
      if (!value) {
        this.getShopsByQuery('');
      }
      this.getShopsByQuery(value);
    },
  },
};
</script>

<style scoped></style>
